import { useEffect, useRef } from 'react';
import {
	useLeftSidebarController,
	useLeftSidebarState,
} from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';

const useAutoExpandSidebar = () => {
	const { expandLeftSidebar } = useLeftSidebarController();
	const { isCollapsed } = useLeftSidebarState();
	const sidebarExpandedRef = useRef(!isCollapsed);

	useEffect(() => {
		if (!sidebarExpandedRef.current && isCollapsed) {
			expandLeftSidebar();
			sidebarExpandedRef.current = true;
		}
	}, [expandLeftSidebar, isCollapsed]);
};

export default useAutoExpandSidebar;
